(function () {
  'use strict';

  var LAPS = 3;
  var WINDOW = 3;
  var WHEEL_THRESHOLD = 28;
  var STEP_COOLDOWN = 380;

  function h(tag, attrs, kids) {
    var el = document.createElement(tag);
    if (attrs) {
      for (var k in attrs) {
        if (k === 'class') el.className = attrs[k];
        else if (k === 'text') el.textContent = attrs[k];
        else if (k.slice(0, 2) === 'on') el.addEventListener(k.slice(2), attrs[k]);
        else if (attrs[k] != null) el.setAttribute(k, attrs[k]);
      }
    }
    (kids || []).forEach(function (kid) { if (kid) el.appendChild(kid); });
    return el;
  }

  function clamp(v, lo, hi) { return v < lo ? lo : v > hi ? hi : v; }

  function readable(hex) {
    if (!hex || hex.charAt(0) !== '#') return false;
    var v = parseInt(hex.slice(1), 16);
    var r = (v >> 16) & 255, g = (v >> 8) & 255, b = v & 255;
    var bright = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    var max = Math.max(r, g, b), min = Math.min(r, g, b);
    var sat = max === 0 ? 0 : (max - min) / max;
    return bright > 0.14 && bright < 0.8 && sat > 0.16;
  }

  function accentOf(item) {
    if (readable(item.shell.hex)) return item.shell.hex;
    if (readable(item.accent.hex)) return item.accent.hex;
    return item.shell.hex;
  }

  function setLines(el, text, slot) {
    el.textContent = '';
    sentences(text).forEach(function (sentence, i) {
      var line = h('span', { class: 'reel__line', text: sentence });
      line.style.setProperty('--i', i * 2 + slot);
      el.appendChild(line);
    });
  }

  function setName(el, shellName, accentName) {
    el.textContent = '';
    el.appendChild(h('span', { class: 'reel__name-part reel__name-part--a', text: shellName }));
    if (accentName) {
      el.appendChild(h('span', { class: 'reel__name-sep', text: ' / ' }));
      el.appendChild(h('span', { class: 'reel__name-part reel__name-part--b', text: accentName }));
    }
  }

  function sentences(text) {
    return (String(text || '').match(/[^.!?]+[.!?]*/g) || [])
      .map(function (raw) { return raw.trim(); })
      .filter(Boolean);
  }

  function money(cents, currency) {
    if (cents == null) return null;
    return new Intl.NumberFormat(undefined, {
      style: 'currency', currency: currency || 'EUR', maximumFractionDigits: 0,
    }).format(cents / 100);
  }

  function Reel(root, catalog, opts) {
    this.root = root;
    this.catalog = catalog;
    this.opts = opts || {};

    this.basePref = 'white';
    this.base = 'white';
    this.active = -1;
    this.locked = false;
    this.wheelAcc = 0;
    this.lastStep = 0;
    this.lastLeft = -1;
    this.settleTimer = null;
    this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    this.shapes = {};
    this.shapesL = {};
    this.shapesR = {};

    this.onScreen = false;

    this.ratios = {};
    this.linesPending = false;

    this.laps = this.opts.driven ? 1 : LAPS;

    this.scroller = root.querySelector('[data-reel-scroller]');
    this.tabs = root.querySelector('[data-reel-tabs]');
    this.tagsOut = root.querySelector('[data-reel-type-tags]');
    this.lineA = root.querySelector('[data-reel-line-a]');
    this.lineB = root.querySelector('[data-reel-line-b]');
    this.indexOut = root.querySelector('[data-reel-index]');
    this.nameOut = root.querySelector('[data-reel-name]');
    this.swatchOut = root.querySelector('[data-reel-swatches]');
    this.basesOut = root.querySelector('[data-reel-bases]');
    this.spectrumOut = root.querySelector('[data-reel-spectrum]');
    this.factsOut = root.querySelector('[data-reel-facts]');
    this.priceOut = root.querySelector('[data-reel-price]');

    this.metaOut = root.querySelector('.reel__meta');

    this.amountOut = root.querySelector('[data-reel-amount]');
    this.addBtn = root.querySelector('[data-reel-add]');
    this.variantInput = root.querySelector('[data-reel-variant]');
    this.viewOut = root.querySelector('[data-reel-view]');

    var lineSrc = root.querySelector('[data-reel-slogans]');
    try {
      this.sloganMap = lineSrc ? JSON.parse(lineSrc.textContent) : {};
    } catch (e) {
      this.sloganMap = {};
    }

    this.view = 'front';

    root.__reel = this;

    this.buildTabs();
    this.buildBases();
    this.buildView();

    this.watchLines();
    this.watchColumn();

    this.warmModels();

    if (document.fonts && document.fonts.ready) {
      var self = this;
      document.fonts.ready.then(function () { self.fitLines(); });
    }
    this.selectModel(this.initialModel(), true);
    this.bind();
    this.loop();
  }

  Reel.prototype.initialModel = function () {
    var want = new URLSearchParams(location.search).get('model');
    var i = this.catalog.models.findIndex(function (m) { return m.slug === want; });
    return i < 0 ? 0 : i;
  };

  Reel.prototype.buildTabs = function () {
    var self = this;
    this.catalog.models.forEach(function (model, i) {
      var btn = h('button', {
        type: 'button', role: 'tab', 'aria-selected': 'false',
        'data-model': model.slug,
        onclick: function () { self.selectModel(i); },
      });
      btn.appendChild(document.createTextNode(model.name));
      btn.appendChild(h('em', { text: String(model.count) }));
      self.tabs.appendChild(btn);
    });
  };

  Reel.prototype.buildBases = function () {
    var self = this;
    ['white', 'black'].forEach(function (base) {
      var btn = h('button', {
        type: 'button', class: 'base-btn', 'data-base': base,
        onclick: function () { self.setBase(base); },
      }, [h('i', {}), document.createTextNode(base === 'white' ? 'White' : 'Black')]);
      btn.querySelector('i').style.background = base === 'black' ? '#17181a' : '#fbfbfa';
      self.basesOut.appendChild(btn);
    });
  };

  Reel.prototype.buildView = function () {
    if (!this.viewOut) return;
    var self = this;
    this.viewOut.addEventListener('click', function () {
      self.setView(self.view === 'back' ? 'front' : 'back');
    });
  };

  var SWAP_OUT = 300;
  var SWAP_IN  = 520;

  Reel.prototype.selectModel = function (i, initial) {
    if (initial || this.reduced || i === this.modelIndex) {
      this.applyModel(i, initial);
      return;
    }

    var self = this, root = this.root;
    this.markTabs(i);

    clearTimeout(this._swapT);
    root.setAttribute('data-turn', 'out');
    this._swapT = setTimeout(function () {
      self.applyModel(i);

      root.removeAttribute('data-turn');
      void root.offsetWidth;
      root.setAttribute('data-turn', 'in');
      self._swapT = setTimeout(function () {
        root.removeAttribute('data-turn');
      }, SWAP_IN);
    }, SWAP_OUT);
  };

  Reel.prototype.markTabs = function (i) {
    if (!this.tabs) return;
    Array.prototype.forEach.call(this.tabs.children, function (b, j) {
      b.setAttribute('aria-selected', j === i ? 'true' : 'false');
    });
  };

  Reel.prototype.applyModel = function (i, initial) {
    this.modelIndex = i;
    this.model = this.catalog.models[i];
    this.items = this.model.colorways;
    this.n = this.items.length;

    this.root.setAttribute('data-model', this.model.slug);

    this.markTabs(i);

    this.render();
    this.renderFacts();
    this.buildSpectrum();
    this.setTypeTags();
    this.setSlogan();
    this.park();
    this.active = -1;
    this.setActive(0);
    this.paint(true);

    if (!initial) {
      var url = new URL(location.href);
      url.searchParams.set('model', this.model.slug);
      history.replaceState(null, '', url);
    }

    if (this.opts.onModel) this.opts.onModel(this.model, !!initial);
  };

  Reel.prototype.render = function () {
    this.scroller.textContent = '';
    this.cards = [];
    for (var lap = 0; lap < this.laps; lap++) {
      for (var i = 0; i < this.n; i++) {
        this.scroller.appendChild(this.card(this.items[i], i));
      }
    }
  };

  Reel.prototype.card = function (item, i) {

    var img = h('img', {
      class: 'card__img',
      alt: this.model.name + ' diffuser in ' + item.name,
      decoding: 'async',
    });
    var card = h('article', { class: 'card', 'data-index': String(i) }, [img]);
    card._img = img;
    card._item = item;
    this.cards.push(card);
    return card;
  };

  Reel.prototype.renderFacts = function () {
    if (!this.factsOut) return;
    var out = this.factsOut;
    var specs = this.model.specs || {};
    var rows = [
      [out.dataset.labelStands || 'Stands', specs.heightRange],
      [out.dataset.labelFootprint || 'Footprint', specs.base],
    ];
    out.textContent = '';
    rows.forEach(function (row) {
      if (!row[1]) return;
      out.appendChild(h('dt', { text: row[0] }));
      out.appendChild(h('dd', { text: row[1] }));
    });
  };

  Reel.prototype.buildSpectrum = function () {
    var self = this;
    this.spectrumOut.textContent = '';
    this.items.forEach(function (item, i) {

      var b = h('button', {
        type: 'button',
        'aria-label': item.name,
        onclick: function () { self.goTo(i); },
      }, [h('span', { class: 'spectrum__name', text: item.name })]);
      b.style.setProperty('--sw', item.shell.hex);
      b.style.setProperty('--sw-accent', item.accent.hex);
      self.spectrumOut.appendChild(b);
    });
  };

  Reel.prototype.cardWidth = function () {
    return this.cards.length ? this.cards[0].getBoundingClientRect().width : 0;
  };

  Reel.prototype.lapWidth = function () { return this.cardWidth() * this.n; };

  Reel.prototype.park = function () {
    var prev = this.scroller.style.scrollSnapType;
    this.scroller.style.scrollSnapType = 'none';
    this.lapStart = this.laps === 1 ? 0 : this.n;
    this.scroller.scrollLeft = this.lapStart * this.cardWidth();
    this.scroller.style.scrollSnapType = prev || '';
    this.activeAbs = this.lapStart;
  };

  Reel.prototype.scrollToAbs = function (abs, smooth) {
    this.scroller.scrollTo({
      left: abs * this.cardWidth(),
      behavior: smooth && !this.reduced ? 'smooth' : 'auto',
    });
  };

  Reel.prototype.drive = function (p) {
    if (!this.cards || !this.cards.length) return;
    var cw = this.cardWidth();
    if (!cw) return;
    var span = this.n - 1;
    var abs = this.lapStart + p * span;
    this.scroller.scrollLeft = abs * cw;

    this.paint(true, abs);
  };

  Reel.prototype.step = function (dir) {
    var now = performance.now();
    if (now - this.lastStep < STEP_COOLDOWN) return;
    this.lastStep = now;
    this.scrollToAbs(this.activeAbs + dir, true);
  };

  Reel.prototype.goTo = function (i) {

    if (this.opts.driven) {
      if (this.opts.onJump) this.opts.onJump(i);
      return;
    }

    var best = null, bestDist = Infinity;
    for (var lap = 0; lap < this.laps; lap++) {
      var abs = lap * this.n + i;
      var d = Math.abs(abs - this.activeAbs);
      if (d < bestDist) { bestDist = d; best = abs; }
    }
    this.lastStep = performance.now();
    this.scrollToAbs(best, true);
  };

  Reel.prototype.paint = function (force, at) {
    var left = this.scroller.scrollLeft;
    if (!force && left === this.lastLeft) return false;
    this.lastLeft = left;

    var cw = this.cardWidth();
    if (!cw) return false;

    var stageW = this.scroller.clientWidth || cw;
    var stageH = this.scroller.clientHeight || 0;
    var stacked = STACKED.matches;

    var pos = at === undefined ? left / cw : at;
    var idxAbs = Math.round(pos);

    var lo = Math.max(0, idxAbs - WINDOW - 1);
    var hi = Math.min(this.cards.length - 1, idxAbs + WINDOW + 1);
    for (var p = lo; p <= hi; p++) {

      var d = p - pos;
      var ad = Math.abs(d);
      var img = this.cards[p]._img;
      var tx, ty;
      if (this.reduced) {

        tx = 0; ty = 0;
      } else if (stacked) {

        tx = d * (stageW - cw);
        ty = 0;
      } else {
        tx = -d * cw;
        ty = -d * stageH;
      }

      var scale = this.reduced ? 1 - 0.16 * clamp(ad, 0, 1.5)
                               : 1 - 0.09 * clamp(ad, 0, 1);
      var op = this.reduced ? clamp(1 - ad * 1.8, 0, 1)
                            : 1 - clamp((ad - 0.86) / 0.22, 0, 1);
      img.style.transform =
        'translate3d(' + tx.toFixed(2) + 'px,' + ty.toFixed(2) + 'px,0) ' +
        'scale(' + scale.toFixed(4) + ')';
      img.style.opacity = op.toFixed(3);
    }

    this.paintChrome(stacked ? pos - idxAbs : null, stageW);

    if (idxAbs !== this.activeAbs) {
      this.activeAbs = idxAbs;
      this.setActive(((idxAbs % this.n) + this.n) % this.n);
    }
    return true;
  };

  Reel.prototype.paintChrome = function (frac, stageW) {
    var meta = this.metaOut;

    if (frac === null || this.reduced) {
      if (meta && this._chrome) meta.style.removeProperty('translate');
      this._chrome = false;
      return;
    }
    this._chrome = true;

    if (meta) meta.style.translate = (-frac * 2 * stageW).toFixed(2) + 'px';
  };

  Reel.prototype.loop = function () {
    var self = this;
    function frame() {
      self.paint(false);
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  };

  Reel.prototype.setActive = function (i) {
    if (i === this.active) return;
    this.active = i;
    var item = this.items[i];

    this.view = 'front';

    this.tint = accentOf(item);
    if (this.opts.onColor) {
      this.opts.onColor(this.tint);
    } else {
      document.documentElement.style.setProperty('--curl', this.tint);
    }

    if (this.indexOut) {
      this.indexOut.textContent = '';
      this.indexOut.appendChild(h('b', { text: String(i + 1).padStart(2, '0') }));
      this.indexOut.appendChild(
        document.createTextNode('/ ' + String(this.n).padStart(2, '0'))
      );
    }

    if (this.nameOut) {
      this.flyName(item.shell.name,
                   item.accent.slug !== item.shell.slug ? item.accent.name : '');
    }

    if (this.swatchOut) {
      this.swatchOut.textContent = '';
      this.swatchOut.appendChild(this.swatch(item.shell));
      if (item.accent.slug !== item.shell.slug) {
        this.swatchOut.appendChild(this.swatch(item.accent));
      }
    }

    this.syncBases(item);

    if (this.spectrumOut) {
      Array.prototype.forEach.call(this.spectrumOut.children, function (b, j) {
        b.setAttribute('aria-current', j === i ? 'true' : 'false');
      });
    }

    if (this.priceOut) {

      var amount = money(this.model.price, this.catalog.currency || this.opts.currency);

      if (this.amountOut) {

        this.priceOut.classList.toggle('buy__price--unpriced', !amount);
        this.amountOut.textContent = amount || this.priceOut.getAttribute('data-unpriced') || 'Price on request';
      } else {
        this.priceOut.textContent = amount || 'Price on request';
      }
    }
    if (this.addBtn) this.addBtn.disabled = !this.opts.canAddToCart;

    this.syncVariant(item);

    this.spinSlogans();

    this.hydrate();
  };

  var NAME_FLIGHT = 720;

  Reel.prototype.flyName = function (shellName, accentName) {
    var el = this.nameOut;
    if (!el) return;

    if (this._nameGhost && this._nameGhost.parentNode) this._nameGhost.remove();
    this._nameGhost = null;
    clearTimeout(this._nameT);

    if (this.reduced) { setName(el, shellName, accentName); return; }

    var host = el.parentNode;
    var leaving = null;
    if (host && el.firstChild) {
      leaving = h('span', { class: 'reel__name reel__name-ghost', 'aria-hidden': 'true' });
      while (el.firstChild) leaving.appendChild(el.firstChild);
    }

    setName(el, shellName, accentName);

    el.removeAttribute('data-play');
    void el.offsetWidth;
    el.setAttribute('data-play', '');

    if (leaving) {

      host.appendChild(leaving);
      this._nameGhost = leaving;
      var self = this;
      this._nameT = setTimeout(function () {
        if (leaving.parentNode) leaving.remove();
        if (self._nameGhost === leaving) self._nameGhost = null;
      }, NAME_FLIGHT);
    }
  };

  Reel.prototype.setSlogan = function () {
    if (!this.lineA) return;
    var entry = this.sloganMap[this.model.slug] || {};
    var pair = [entry.left || '', entry.right || ''];
    if (this._linePair && pair[0] === this._linePair[0] && pair[1] === this._linePair[1]) return;
    this._linePair = pair;

    this._seq = sentences(pair[0]).concat(sentences(pair[1]));
    this._spin = 0;

    var self = this;
    var a = this.lineA, bEl = this.lineB;
    a.parentNode.setAttribute('data-swap', '');
    if (bEl) bEl.parentNode.setAttribute('data-swap', '');
    clearTimeout(this._lineT);
    this._lineT = setTimeout(function () {
      setLines(a, pair[0], 0);
      if (bEl) setLines(bEl, pair[1], 1);
      a.parentNode.removeAttribute('data-swap');
      if (bEl) bEl.parentNode.removeAttribute('data-swap');

      self.root.removeAttribute('data-spun');
      self.fitLines();
      self.playLines();
    }, this.reduced ? 0 : 170);
  };

  var SPIN_MS = 1250;
  var SPIN_TURN = 62;
  var SPIN_DEPTH = 0.42;
  var SPIN_STEPS = 18;
  var SPIN_EASE = 'cubic-bezier(0.33, 0.02, 0.24, 1)';

  Reel.prototype.lineEls = function () {
    var out = [];
    [this.lineA, this.lineB].forEach(function (host) {
      if (!host) return;
      var ls = host.querySelectorAll('.reel__line');
      for (var i = 0; i < ls.length; i++) out.push(ls[i]);
    });
    return out;
  };

  Reel.prototype.writeSpin = function (els) {
    var seq = this._seq || [], n = seq.length;
    if (!n) return;
    for (var s = 0; s < els.length; s++) els[s].textContent = seq[(s + this._spin) % n];
  };

  function inkOf(el) {
    var r = document.createRange();
    r.selectNodeContents(el);
    var b = r.getBoundingClientRect();
    r.detach && r.detach();
    return {
      cx: (b.left + b.right) / 2, cy: (b.top + b.bottom) / 2,
      w: b.width,
      size: parseFloat(getComputedStyle(el).fontSize) || 0,
    };
  }

  Reel.prototype.spinSlogans = function () {
    if (!this.lineA || !this._seq || this._seq.length < 2) return;

    if (STACKED.matches || this.root.hasAttribute('data-cramped')) return;

    if (!this.onScreen) return;

    var els = this.lineEls(), n = this._seq.length;
    if (els.length !== n) return;

    if (this.reduced) {
      this._spin = (this._spin + 1) % n;
      this.writeSpin(els);
      fitLines(this.root);
      return;
    }

    this.root.setAttribute('data-spun', '');
    [this.lineA, this.lineB].forEach(function (host) {
      if (host) host.parentNode.removeAttribute('data-play');
    });

    var before = els.map(inkOf), i;
    for (i = 0; i < els.length; i++) if (els[i].__orbit) els[i].__orbit.cancel();

    this._spin = (this._spin + 1) % n;
    this.writeSpin(els);

    fitLines(this.root);

    orbit(els, before, els.map(inkOf));
  };

  function orbit(els, before, after) {
    var n = els.length, i, TAU = Math.PI * 2;

    var cx = 0, cy = 0;
    for (i = 0; i < n; i++) { cx += after[i].cx; cy += after[i].cy; }
    cx /= n; cy /= n;

    if (n === 3) {
      var A = after[0], B = after[1], C = after[2];
      var d = 2 * (A.cx * (B.cy - C.cy) + B.cx * (C.cy - A.cy) + C.cx * (A.cy - B.cy));
      if (Math.abs(d) > 1e-6) {
        var qa = A.cx * A.cx + A.cy * A.cy;
        var qb = B.cx * B.cx + B.cy * B.cy;
        var qc = C.cx * C.cx + C.cy * C.cy;
        var ox = (qa * (B.cy - C.cy) + qb * (C.cy - A.cy) + qc * (A.cy - B.cy)) / d;
        var oy = (qa * (C.cx - B.cx) + qb * (A.cx - C.cx) + qc * (B.cx - A.cx)) / d;
        var rad = Math.sqrt((A.cx - ox) * (A.cx - ox) + (A.cy - oy) * (A.cy - oy));
        var span = Math.max(
          Math.abs(A.cx - B.cx) + Math.abs(A.cy - B.cy),
          Math.abs(B.cx - C.cx) + Math.abs(B.cy - C.cy),
          Math.abs(C.cx - A.cx) + Math.abs(C.cy - A.cy));
        if (rad < 3 * span) { cx = ox; cy = oy; }
      }
    }

    var moves = [];
    for (i = 0; i < n; i++) {
      var f = before[(i + 1) % n], t = after[i];
      if (!(f.w > 0) || !(t.w > 0) || !(t.size > 0)) return;
      moves.push({
        el: els[i], f: f, t: t,
        a0: Math.atan2(f.cy - cy, f.cx - cx), a1: Math.atan2(t.cy - cy, t.cx - cx),
        r0: Math.sqrt((f.cx - cx) * (f.cx - cx) + (f.cy - cy) * (f.cy - cy)),
        r1: Math.sqrt((t.cx - cx) * (t.cx - cx) + (t.cy - cy) * (t.cy - cy)),
      });
    }

    var sumP = 0, sumN = 0;
    for (i = 0; i < n; i++) {
      var d = moves[i].a1 - moves[i].a0;
      sumP += ((d % TAU) + TAU) % TAU;
      sumN += ((((-d) % TAU) + TAU) % TAU);
    }
    var fwd = Math.abs(sumP - TAU) <= Math.abs(sumN - TAU);

    var radius = 0;
    for (i = 0; i < n; i++) radius += moves[i].r1;
    var depth = SPIN_DEPTH * (radius / n);

    for (i = 0; i < n; i++) {
      var m = moves[i];
      var turn = m.a1 - m.a0;
      turn = fwd ? ((turn % TAU) + TAU) % TAU : -((((-turn) % TAU) + TAU) % TAU);

      var box = m.el.getBoundingClientRect();
      m.el.style.transformOrigin =
        (m.t.cx - box.left).toFixed(1) + 'px ' + (m.t.cy - box.top).toFixed(1) + 'px';

      var s0 = m.t.w > 0 ? m.f.w / m.t.w : 1;
      var frames = [];
      for (var k = 0; k <= SPIN_STEPS; k++) {
        var p = k / SPIN_STEPS;
        var a = m.a0 + turn * p;
        var r = m.r0 + (m.r1 - m.r0) * p;
        var arc = Math.sin(Math.PI * p);
        frames.push({
          transform:
            'perspective(1600px) translate3d(' +
              (cx + r * Math.cos(a) - m.t.cx).toFixed(2) + 'px,' +
              (cy + r * Math.sin(a) - m.t.cy).toFixed(2) + 'px,' +
              (-depth * arc).toFixed(2) + 'px) ' +
            'rotateY(' + ((fwd ? -1 : 1) * SPIN_TURN * arc).toFixed(2) + 'deg) ' +
            'scale(' + (s0 + (1 - s0) * p).toFixed(4) + ')',
        });
      }

      if (m.el.__orbit) m.el.__orbit.cancel();
      var anim = m.el.animate(frames, {
        duration: SPIN_MS, easing: SPIN_EASE, fill: 'none',
      });
      m.el.__orbit = anim;
      (function (el) {
        anim.finished.then(function () {
          el.style.removeProperty('transform-origin');
        }, function () {  });
      })(m.el);
    }
  }

  Reel.prototype.playLines = function () {
    if (!this.lineA) return;
    if (!this.onScreen) { this.linesPending = true; return; }
    this.linesPending = false;

    [this.lineA, this.lineB].forEach(function (el) {
      if (!el) return;
      var side = el.parentNode;
      side.removeAttribute('data-play');

      void side.offsetWidth;
      side.setAttribute('data-play', '');
    });
  };

  var STACKED = window.matchMedia('(orientation: portrait), (max-width: 760px)');

  var FIT_REF = 100;

  var FIT_SAFE = 0.998;

  var SLOT_LEAD = 1.5;

  var FIT_LH = 1.08;
  var GAP_MIN_EM = 0.4;
  var GAP_VH = 0.025;
  var GAP_MAX_EM = 0.9;

  function textWidth(el) {
    var r = document.createRange();
    r.selectNodeContents(el);
    var w = r.getBoundingClientRect().width;
    r.detach && r.detach();
    return w;
  }

  function lineGap(base) {
    return Math.min(GAP_MAX_EM * base,
                    Math.max(GAP_MIN_EM * base, GAP_VH * window.innerHeight));
  }

  function unfit(root) {
    root.removeAttribute('data-fitted');
    root.style.removeProperty('--slogan-fit');
    var sides = root.querySelectorAll('.reel__side');
    for (var i = 0; i < sides.length; i++) {
      sides[i].style.removeProperty('--slogan-fit');
      var lines = sides[i].querySelectorAll('.reel__line');
      for (var j = 0; j < lines.length; j++) {
        lines[j].style.removeProperty('font-size');
        lines[j].style.removeProperty('padding-left');
        lines[j].style.removeProperty('padding-right');
      }
    }
  }

  function productInk(root) {

    var cards = root.querySelectorAll('.card');
    var mid = window.innerWidth / 2, best = null, bestImg = null, bestD = Infinity;
    for (var i = 0; i < cards.length; i++) {
      var r = cards[i].getBoundingClientRect();
      if (!r.width || !r.height) continue;

      var cimg = cards[i].querySelector('img');
      if (!cimg || !cimg.naturalWidth || !cimg.naturalHeight) continue;
      var d = Math.abs((r.left + r.right) / 2 - mid);
      if (d < bestD) { bestD = d; best = cards[i]; bestImg = cimg; }
    }
    var img = bestImg;
    if (!best) return null;
    var b = best.getBoundingClientRect();
    var cs = getComputedStyle(best);
    var bw = b.width - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
    var bh = b.height - parseFloat(cs.paddingTop) - parseFloat(cs.paddingBottom);
    if (!(bw > 0) || !(bh > 0)) return null;
    var sc = Math.min(bw / img.naturalWidth, bh / img.naturalHeight);
    var h = img.naturalHeight * sc;

    return {
      cx: mid, w: img.naturalWidth * sc,
      top: b.bottom - parseFloat(cs.paddingBottom) - h, h: h,
    };
  }

  function widestIn(shape, t0, t1) {
    if (!shape || !shape.length) return 0.5;
    var n = shape.length;
    var a = Math.max(0, Math.min(n - 1, Math.floor(Math.min(t0, t1) * n)));
    var b = Math.max(a, Math.min(n - 1, Math.ceil(Math.max(t0, t1) * n) - 1));
    var most = 0;
    for (var i = a; i <= b; i++) if (shape[i] > most) most = shape[i];
    return most || 0.5;
  }

  function clearance() {
    return Math.max(18, Math.min(40, window.innerWidth * 0.02));
  }

  function fitLines(root) {
    var sides = root.querySelectorAll('.reel__side');
    if (!sides.length) return;

    if (STACKED.matches) {
      unfit(root);
      return;
    }

    for (var k = 0; k < sides.length; k++) {
      if (getComputedStyle(sides[k]).display === 'none') {
        unfit(root);
        return;
      }
    }

    root.setAttribute('data-fitted', '');

    var ink = productInk(root);
    var shape = root.__shape;
    var clear = clearance();

    var quad = nameQuad(root);
    var plan = [];

    for (var i = 0; i < sides.length; i++) {
      var side = sides[i];
      var lines = side.querySelectorAll('.reel__line');
      if (!lines.length) continue;

      var cs = getComputedStyle(side);
      var box = side.getBoundingClientRect();

      var left = ink ? (box.left + box.right) / 2 < ink.cx
                     : side.classList.contains('reel__side--l');
      var outerL = box.left + parseFloat(cs.paddingLeft);
      var outerR = box.right - parseFloat(cs.paddingRight);
      var top = box.top + parseFloat(cs.paddingTop);
      var room = box.height - parseFloat(cs.paddingTop) - parseFloat(cs.paddingBottom);
      var n = lines.length, j;
      var slot = room / n;
      if (!(outerR - outerL > 0) || !(slot > 0)) {
        unfit(root);
        return;
      }

      var ink0 = [];
      for (j = 0; j < n; j++) lines[j].style.fontSize = FIT_REF + 'px';
      for (j = 0; j < n; j++) ink0.push(textWidth(lines[j]));

      var want = [], availW = [], openL = [], openR = [];
      for (j = 0; j < n; j++) {
        want.push(0); availW.push(outerR - outerL);
        openL.push(outerL); openR.push(outerR);
      }

      for (var pass = 0; pass < 4; pass++) {
        for (j = 0; j < n; j++) {
          var mid = top + slot * (j + 0.5);
          var lineH = pass === 0 ? slot : Math.min(slot, want[j] * FIT_LH);
          var op = openingAt(ink, shape, clear, left, outerL, outerR,
                             mid - lineH / 2, mid + lineH / 2, quad);
          availW[j] = op.w; openL[j] = op.l; openR[j] = op.r;
          want[j] = ink0[j] > 0 ? availW[j] / ink0[j] * FIT_REF : 0;

          want[j] = Math.min(want[j], slot / SLOT_LEAD);
          if (want[j] < 0) want[j] = 0;
        }
      }

      for (j = 0; j < n; j++) lines[j].style.fontSize = want[j].toFixed(2) + 'px';
      for (j = 0; j < n; j++) {
        var w2 = textWidth(lines[j]);
        if (w2 > 0) {
          want[j] = Math.min(want[j] * (availW[j] / w2) * FIT_SAFE, slot / SLOT_LEAD);
        }
      }

      var pad = [];
      for (j = 0; j < n; j++) {
        var m2 = top + slot * (j + 0.5);
        var h2 = Math.min(slot, want[j] * FIT_LH);
        var last = openingAt(ink, shape, clear, left, outerL, outerR,
                             m2 - h2 / 2, m2 + h2 / 2, quad);
        if (last.w < availW[j]) {
          availW[j] = last.w;
          lines[j].style.fontSize = want[j].toFixed(2) + 'px';
          var w3 = textWidth(lines[j]);
          if (w3 > last.w) want[j] = want[j] * (last.w / w3) * FIT_SAFE;
        }
        openL[j] = last.l; openR[j] = last.r;

        pad.push({ l: Math.max(0, openL[j] - outerL),
                   r: Math.max(0, outerR - openR[j]) });
      }

      plan.push({ side: side, lines: lines, want: want, pad: pad, left: left });
    }

    if (!plan.length) {
      unfit(root);
      return;
    }

    for (i = 0; i < plan.length; i++) {
      var p = plan[i], big = Math.max.apply(null, p.want);

      p.side.style.setProperty('--slogan-fit', big.toFixed(2) + 'px');
      for (var m = 0; m < p.lines.length; m++) {
        var el = p.lines[m];
        el.style.fontSize = p.want[m].toFixed(2) + 'px';
        el.style.paddingLeft = p.pad[m].l.toFixed(2) + 'px';
        el.style.paddingRight = p.pad[m].r.toFixed(2) + 'px';
      }
    }
  }

  function fitSwitch(root) {

    var self = root.__reel || { catalog: { models: [] }, shapes: {}, shapesL: {}, ratios: {} };
    var id = root.querySelector('.reel__id');
    var tabs = root.querySelector('.models');
    var tags = root.querySelector('.reel__type-tags');

    function drop() {
      root.style.removeProperty('--bay');
      root.style.removeProperty('--bay-pull');
    }

    if (!id || !tabs || STACKED.matches) return drop();

    var ink = productInk(root);
    if (!ink || !(ink.h > 0) || !(ink.w > 0)) return drop();

    var rootL = root.getBoundingClientRect().left;
    var pull = id.getBoundingClientRect().left - rootL;
    var clear = clearance();

    var boxH = ink.h;

    function reachOver(top, bot) {
      var most = 0, any = false;
      self.catalog.models.forEach(function (m) {
        var shape = self.shapesL[m.slug] || self.shapes[m.slug];
        var ratio = self.ratios[m.slug];
        if (!shape || !shape.length || !(ratio > 0)) return;
        var reach = widestIn(shape, (top - ink.top) / boxH, (bot - ink.top) / boxH)
                    * (boxH / ratio);
        if (reach > most) most = reach;
        any = true;
      });
      if (any) return most;

      return widestIn(root.__shapeL || root.__shape,
                      (top - ink.top) / ink.h, (bot - ink.top) / ink.h) * ink.w;
    }

    for (var pass = 0; pass < 2; pass++) {
      var a = tabs.getBoundingClientRect();
      var b = tags && getComputedStyle(tags).display !== 'none'
        ? tags.getBoundingClientRect() : a;
      var top = Math.min(a.top, b.top), bot = Math.max(a.bottom, b.bottom);
      var bay = ink.cx - reachOver(top, bot) - clear - rootL;
      if (!(bay > 0)) return drop();
      root.style.setProperty('--bay-pull', pull.toFixed(2) + 'px');
      root.style.setProperty('--bay', bay.toFixed(2) + 'px');
    }
  }

  function nameQuad(root) {
    var el = root.querySelector('.reel__name');
    if (!el) return null;
    var sq = parseFloat(getComputedStyle(root).getPropertyValue('--name-sq'));
    if (!(sq > 0)) return null;
    var box = el.getBoundingClientRect();
    if (!(box.width > 0)) return null;

    var fs = sq / NAME_DIV;
    var a = NAME_EM * fs / 2, b = NAME_LH * fs / 2;
    var cx = (box.left + box.right) / 2, cy = (box.top + box.bottom) / 2;

    var k = Math.SQRT1_2;
    var out = [];
    for (var i = 0; i < 4; i++) {
      var sa = (i === 0 || i === 1) ? 1 : -1;
      var sb = (i === 0 || i === 3) ? 1 : -1;
      out.push([cx + (sa * a + sb * b) * k, cy + (-sa * a + sb * b) * k]);
    }
    return out;
  }

  function quadLeftIn(quad, y0, y1) {
    if (!quad) return Infinity;
    var ys = [y0, y1], i;
    for (i = 0; i < 4; i++) if (quad[i][1] > y0 && quad[i][1] < y1) ys.push(quad[i][1]);
    var best = Infinity;
    for (var k = 0; k < ys.length; k++) {
      var y = ys[k], hit = Infinity;
      for (i = 0; i < 4; i++) {
        var p = quad[i], q = quad[(i + 1) % 4];
        var dy = q[1] - p[1];
        if (dy === 0) continue;
        var t = (y - p[1]) / dy;
        if (t < 0 || t > 1) continue;
        var x = p[0] + t * (q[0] - p[0]);
        if (x < hit) hit = x;
      }
      if (hit < best) best = hit;
    }
    return best;
  }

  function openingAt(ink, shape, clear, left, outerL, outerR, y0, y1, quad) {

    if (quad) {
      var cut = quadLeftIn(quad, y0, y1);
      if (cut < Infinity) outerR = Math.min(outerR, cut - clear);
    }
    if (outerR <= outerL) return { w: 0, l: outerL, r: outerL };
    if (!ink || !(ink.h > 0)) return { w: outerR - outerL, l: outerL, r: outerR };
    var half = widestIn(shape, (y0 - ink.top) / ink.h, (y1 - ink.top) / ink.h) * ink.w;
    var edge = left ? ink.cx - half - clear : ink.cx + half + clear;
    var l = left ? outerL : Math.max(outerL, edge);
    var r = left ? Math.min(outerR, edge) : outerR;
    return { w: Math.max(0, r - l), l: l, r: Math.max(l, r) };
  }

  var NAME_EM = 8.3, NAME_LH = 1.84;
  var NAME_DIV = (NAME_EM + NAME_LH) / Math.SQRT2;
  var NAME_APEX = NAME_EM / (NAME_EM + NAME_LH);

  function boxHit(quad, r) {
    if (!r || !(r.width > 0)) return false;
    var axes = [[1, 0], [0, 1], [0.7071, -0.7071], [0.7071, 0.7071]];
    var rect = [[r.left, r.top], [r.right, r.top], [r.right, r.bottom], [r.left, r.bottom]];
    for (var a = 0; a < 4; a++) {
      var ax = axes[a][0], ay = axes[a][1];
      var qmin = Infinity, qmax = -Infinity, rmin = Infinity, rmax = -Infinity, i, p;
      for (i = 0; i < 4; i++) {
        p = quad[i][0] * ax + quad[i][1] * ay;
        if (p < qmin) qmin = p;
        if (p > qmax) qmax = p;
        p = rect[i][0] * ax + rect[i][1] * ay;
        if (p < rmin) rmin = p;
        if (p > rmax) rmax = p;
      }
      if (qmax <= rmin || rmax <= qmin) return false;
    }
    return true;
  }

  function fitName(root) {
    var meta = root.querySelector('.reel__meta');
    if (!meta) return;
    if (STACKED.matches) { root.style.removeProperty('--name-sq'); return; }

    var ink = productInk(root);
    var shape = root.__shapeR || root.__shape;
    if (!ink || !(ink.h > 0) || !shape || !shape.length) return;

    var box = meta.getBoundingClientRect();
    var R = box.right, T = box.top, H = box.height;
    if (!(H > 0) || !(R > ink.cx)) return;

    var clear = clearance();
    var n = shape.length;

    var idx = root.querySelector('[data-reel-index]');
    var buy = root.querySelector('.buy');
    var idxBox = idx ? idx.getBoundingClientRect() : null;
    var buyBox = buy ? buy.getBoundingClientRect() : null;
    var floor = root.getBoundingClientRect().bottom;

    function reach(y) {
      var t = (y - ink.top) / ink.h;
      if (t < 0 || t >= 1) return -Infinity;
      return ink.cx + shape[Math.floor(t * n)] * ink.w;
    }

    function footGap(fx, fy) {
      for (var t = 0; t <= 500; t += 1) {
        var x = fx - t / Math.SQRT2, y = fy + t / Math.SQRT2;
        if (y >= ink.top + ink.h) return 500;
        if (x <= reach(y)) return t;
      }
      return 500;
    }

    function place(S, off) {
      var o = off / Math.SQRT2, k = clear / Math.SQRT2;
      var Y0 = T + k + o, X0 = R - NAME_APEX * S - k - o;
      var t = 0.1815 * S;
      return { X0: X0, Y0: Y0, S: S,
               head: [X0 + NAME_APEX * S, Y0],
               foot: [X0, Y0 + NAME_APEX * S],
               quad: [[X0, Y0 + NAME_APEX * S], [X0 + NAME_APEX * S, Y0],
                      [X0 + S, Y0 + t], [X0 + t, Y0 + S]] };
    }

    function fits(S, off) {
      var q = place(S, off);
      if (q.Y0 + S > floor) return false;
      if (footGap(q.foot[0], q.foot[1]) < clear) return false;
      if (boxHit(q.quad, idxBox) || boxHit(q.quad, buyBox)) return false;

      var side = clear * 0.7, apex = q.Y0 + NAME_APEX * S;
      for (var i = 0; i < n; i++) {
        var y0 = ink.top + (i / n) * ink.h, y1 = ink.top + ((i + 1) / n) * ink.h;
        if (y1 < q.Y0 || y0 > q.Y0 + S) continue;
        var y = Math.max(y0, Math.min(y1, apex));
        if (q.X0 + Math.abs(y - apex) < ink.cx + shape[i] * ink.w + side) return false;
      }
      return true;
    }

    function biggest(off) {
      var hi = Math.min(floor - T, (R - clear / Math.SQRT2 - off / Math.SQRT2 - ink.cx) / NAME_APEX);
      if (!(hi > 0)) return 0;
      if (fits(hi, off)) return hi;
      var lo = 0;
      for (var k = 0; k < 14; k++) {
        var mid = (lo + hi) / 2;
        if (fits(mid, off)) lo = mid; else hi = mid;
      }
      return lo;
    }

    var best = biggest(0), bestOff = 0;
    if (best > 0) {
      for (var off = 0; off <= 240; off += 6) {
        var S = biggest(off);
        if (!(S > 0)) break;
        var q = place(S, off);
        best = S; bestOff = off;
        if (footGap(q.foot[0], q.foot[1]) <= clear + off) break;
      }
    }
    if (!(best > 0)) return;
    root.style.setProperty('--name-sq', best.toFixed(2) + 'px');
    root.style.setProperty('--name-slide', bestOff.toFixed(2) + 'px');
  }

  Reel.prototype.fitLines = function () {

    var flying = this.lineEls();
    for (var f = 0; f < flying.length; f++) {
      if (flying[f].__orbit) flying[f].__orbit.cancel();
    }

    this.root.__shape = (this.model && this.shapes[this.model.slug]) || null;
    this.root.__shapeL = (this.model && this.shapesL[this.model.slug]) || null;
    this.root.__shapeR = (this.model && this.shapesR[this.model.slug]) || null;

    fitName(this.root);
    if (this.lineA) fitLines(this.root);

    fitSwitch(this.root);
  };

  Reel.prototype.warmModels = function () {
    var self = this;
    this.catalog.models.forEach(function (m) {
      var item = m.colorways && m.colorways[0];
      var src = item && self.srcFor(item, 300);
      if (!src) return;
      var probe = new Image();
      probe.decoding = 'async';
      probe.setAttribute('fetchpriority', 'low');

      probe.crossOrigin = 'anonymous';
      probe.onload = function () { self.learnShape(m.slug, probe); };
      probe.src = src;
    });
  };

  var SHAPE_ROWS = 64;
  var SOLID_ALPHA = 128;

  Reel.prototype.learnShape = function (slug, img) {
    var w = img.naturalWidth, h = img.naturalHeight;
    if (!w || !h) return;

    this.ratios[slug] = h / w;
    var data;
    try {
      var c = document.createElement('canvas');
      c.width = w; c.height = h;
      var cx = c.getContext('2d', { willReadFrequently: true });
      cx.drawImage(img, 0, 0);
      data = cx.getImageData(0, 0, w, h).data;
    } catch (e) {
      return;
    }

    var rows = new Array(SHAPE_ROWS), left = new Array(SHAPE_ROWS);
    var right = new Array(SHAPE_ROWS), i;
    for (i = 0; i < SHAPE_ROWS; i++) { rows[i] = 0; left[i] = 0; right[i] = -0.5; }
    for (var y = 0; y < h; y++) {
      var lo = -1, hi = -1, x;
      for (x = 0; x < w; x++) { if (data[(y * w + x) * 4 + 3] > SOLID_ALPHA) { lo = x; break; } }
      if (lo < 0) continue;
      for (x = w - 1; x >= 0; x--) { if (data[(y * w + x) * 4 + 3] > SOLID_ALPHA) { hi = x; break; } }

      var lHalf = (w / 2 - lo) / w;
      var rHalf = (hi + 1 - w / 2) / w;
      var half = Math.max(lHalf, rHalf);
      var band = Math.min(SHAPE_ROWS - 1, Math.floor(y / h * SHAPE_ROWS));
      if (half > rows[band]) rows[band] = half;

      if (lHalf > left[band]) left[band] = lHalf;

      if (rHalf > right[band]) right[band] = rHalf;
    }
    for (i = 0; i < SHAPE_ROWS; i++) if (left[i] < 0) left[i] = 0;
    this.shapes[slug] = rows;
    this.shapesL[slug] = left;
    this.shapesR[slug] = right;
    this.fitLines();
  };

  Reel.prototype.widestBetween = function (t0, t1) {
    var rows = this.shapes && this.shapes[this.model && this.model.slug];
    if (!rows) return 0.5;
    var a = Math.max(0, Math.min(SHAPE_ROWS - 1, Math.floor(Math.min(t0, t1) * SHAPE_ROWS)));
    var b = Math.max(0, Math.min(SHAPE_ROWS - 1, Math.ceil(Math.max(t0, t1) * SHAPE_ROWS) - 1));
    var most = 0;
    for (var i = a; i <= b; i++) if (rows[i] > most) most = rows[i];
    return most || 0.5;
  };

  Reel.prototype.watchColumn = function () {
    var self = this;
    if (!this.lineA || !('ResizeObserver' in window)) return;
    var last = -1, pending = 0;
    new ResizeObserver(function (entries) {
      var w = Math.round(entries[0].contentRect.width);
      if (w === last) return;
      last = w;

      if (pending) return;
      pending = requestAnimationFrame(function () {
        pending = 0;
        self.fitLines();
      });
    }).observe(this.lineA.parentNode);
  };

  Reel.prototype.watchLines = function () {
    var self = this;
    if (!this.lineA) return;

    if (!('IntersectionObserver' in window)) {
      this.onScreen = true;
      return;
    }
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        self.onScreen = true;
        if (self.linesPending) self.playLines();
      });
    }, { threshold: 0.2 }).observe(this.root);
  };

  Reel.prototype.setTypeTags = function () {
    if (!this.tagsOut) return;
    var entry = this.sloganMap[this.model.slug] || {};
    var tags = entry.tags || '';
    if (tags === this._tags) return;
    this._tags = tags;

    var el = this.tagsOut;
    el.setAttribute('data-swap', '');
    clearTimeout(this._tagsT);
    this._tagsT = setTimeout(function () {
      el.textContent = tags;
      el.removeAttribute('data-swap');
    }, this.reduced ? 0 : 170);
  };

  Reel.prototype.swatch = function (color) {
    var el = h('span', { class: 'swatch' }, [h('i', {}), document.createTextNode(color.name)]);
    el.querySelector('i').style.setProperty('--sw', color.hex);
    return el;
  };

  Reel.prototype.syncBases = function (item) {
    var self = this;
    this.base = this.shownBase(item);
    Array.prototype.forEach.call(this.basesOut.children, function (b) {
      var base = b.dataset.base;
      b.disabled = !item.bases[base];
      b.setAttribute('aria-pressed', String(base === self.base && !b.disabled));
    });
    this.syncView(item);
  };

  Reel.prototype.shownBase = function (item) {
    return item.bases[this.basePref] ? this.basePref
         : (item.bases.white ? 'white' : 'black');
  };

  Reel.prototype.syncView = function (item) {
    if (!this.viewOut) return;
    var img = item.bases[this.base];
    var has = !!(img && img.back);
    this.viewOut.hidden = !has;
    if (!has) this.view = 'front';

    var back = this.view === 'back';
    this.viewOut.textContent = back
      ? this.viewOut.getAttribute('data-label-front') || 'Front view'
      : this.viewOut.getAttribute('data-label-back') || 'Back view';
    this.viewOut.setAttribute('aria-pressed', String(back));
  };

  Reel.prototype.setView = function (view) {
    if (this.view === view) return;
    this.view = view;
    this.syncView(this.items[this.active]);
    this.hydrate(true);
  };

  Reel.prototype.syncVariant = function (item) {
    var chosen = item && (item.bases[this.base] || item.bases.white || item.bases.black);
    if (this.variantInput && chosen && chosen.variantId) {
      this.variantInput.value = chosen.variantId;
    }
  };

  Reel.prototype.setBase = function (base) {
    this.basePref = base;
    this.base = base;

    this.view = 'front';
    this.syncBases(this.items[this.active]);
    this.syncVariant(this.items[this.active]);
    this.hydrate(true);
  };

  Reel.prototype.imageFor = function (item) {
    var img = item.bases[this.base] || item.bases.white || item.bases.black;
    if (!img) return null;
    return this.view === 'back' && img.back ? img.back : img;
  };

  Reel.prototype.srcFor = function (item, width) {
    var img = this.imageFor(item);
    if (!img) return null;
    if (img.url) return img.url;
    return this.opts.assetBase.replace('__FILE__', img.asset + '-' + width + '.webp');
  };

  Reel.prototype.hydrate = function (force) {
    var abs = this.activeAbs == null ? 0 : this.activeAbs;
    for (var p = 0; p < this.cards.length; p++) {
      var card = this.cards[p];
      if (Math.abs(p - abs) > WINDOW) {
        if (card._img.getAttribute('src')) {
          card._img.removeAttribute('src');
          card._img.removeAttribute('srcset');
        }
        continue;
      }
      var want = this.srcFor(card._item, 1050);
      if (!want) continue;
      if (force || card._img.getAttribute('src') !== want) {
        card._img.setAttribute('src', want);
        var rec = this.imageFor(card._item);
        if (!rec || !rec.url) {
          card._img.setAttribute('srcset',
            this.srcFor(card._item, 300) + ' 300w, ' +
            this.srcFor(card._item, 600) + ' 600w, ' +
            this.srcFor(card._item, 1050) + ' 1050w');
          card._img.setAttribute('sizes', '(max-width: 760px) 78vw, min(46vw, 30rem)');
        }
      }
    }
  };

  Reel.prototype.settle = function () {
    var self = this;
    clearTimeout(this.settleTimer);
    this.settleTimer = setTimeout(function () { self.rebase(); }, 140);
  };

  Reel.prototype.rebase = function () {
    if (this.locked || this.laps === 1) return;
    var n = this.n;
    var idxAbs = this.activeAbs;
    var shift = 0;
    if (idxAbs < Math.round(n * 0.5)) shift = 1;
    else if (idxAbs >= Math.round(n * 2.5)) shift = -1;
    if (!shift) return;

    this.locked = true;
    var snap = this.scroller.style.scrollSnapType;
    this.scroller.style.scrollSnapType = 'none';
    this.scroller.scrollLeft += shift * this.lapWidth();
    this.scroller.style.scrollSnapType = snap || '';
    this.activeAbs = idxAbs + shift * n;
    this.lastLeft = -1;
    this.locked = false;

    this.hydrate();
    this.paint(true);
  };

  Reel.prototype.bind = function () {
    var self = this;

    var rz;
    window.addEventListener('resize', function () {
      clearTimeout(rz);
      rz = setTimeout(function () {
        self.park();
        self.lastLeft = -1;
        self.paint(true);

        self.fitLines();
      }, 200);
    });

    if (this.opts.driven) {

      this.scroller.style.scrollSnapType = 'none';
      this.scroller.style.overflowX = 'hidden';
      return;
    }

    this.scroller.addEventListener('scroll', function () { self.settle(); }, { passive: true });

    this.scroller.addEventListener('wheel', function (e) {
      var dy = Math.abs(e.deltaY) > Math.abs(e.deltaX) ? e.deltaY : e.deltaX;
      if (!dy) return;
      e.preventDefault();
      self.wheelAcc += dy;
      if (Math.abs(self.wheelAcc) >= WHEEL_THRESHOLD) {
        self.step(self.wheelAcc > 0 ? 1 : -1);
        self.wheelAcc = 0;
      }
    }, { passive: false });

    this.scroller.addEventListener('keydown', function (e) {
      var dir = e.key === 'ArrowRight' || e.key === 'ArrowDown' || e.key === 'PageDown' ? 1
              : e.key === 'ArrowLeft' || e.key === 'ArrowUp' || e.key === 'PageUp' ? -1 : 0;
      if (!dir) return;
      e.preventDefault();
      self.step(dir);
    });

  };

  function norm(s) {
    return String(s == null ? '' : s).toLowerCase().replace(/[^a-z0-9]+/g, '');
  }

  function findModel(bundled, model) {
    var slug = norm(model.slug);
    var name = norm(model.name);
    for (var i = 0; i < bundled.length; i++) {
      var b = bundled[i], bs = norm(b.slug);
      if (bs && (bs === slug || (slug && slug.slice(-bs.length) === bs) ||
                 (name && name.indexOf(norm(b.name)) >= 0))) {
        return b;
      }
    }
    return null;
  }

  function findColorway(bundled, cw) {
    var byName = norm(cw.name);
    var byPair = norm((cw.shell && cw.shell.slug) + '-' + (cw.accent && cw.accent.slug));
    for (var i = 0; i < bundled.length; i++) {
      var b = bundled[i];
      if (norm(b.name) === byName || norm(b.handle) === byPair || norm(b.handle) === byName) {
        return b;
      }
    }
    return null;
  }

  function withBundled(shop, bundled) {
    if (!shop || !bundled || !bundled.models) return shop;

    shop.models.forEach(function (model) {
      var bm = findModel(bundled.models, model);
      if (!bm) return;

      if (bm.slug) model.slug = bm.slug;
      if (bm.name && norm(model.name).indexOf(norm(bm.name)) >= 0) model.name = bm.name;

      ['tagline', 'blurb', 'bestFor', 'ptName'].forEach(function (k) {
        if (!model[k] && bm[k]) model[k] = bm[k];
      });
      model.specs = model.specs || {};
      Object.keys(bm.specs || {}).forEach(function (k) {
        if (!model.specs[k]) model.specs[k] = bm.specs[k];
      });

      (model.colorways || []).forEach(function (cw) {
        var bc = findColorway(bm.colorways || [], cw);
        if (!bc) return;

        ['shell', 'accent'].forEach(function (half) {
          cw[half] = cw[half] || {};
          if (!cw[half].hex && bc[half]) cw[half].hex = bc[half].hex;
          if (!cw[half].name && bc[half]) cw[half].name = bc[half].name;
        });

        Object.keys(cw.bases || {}).forEach(function (base) {
          var rec = cw.bases[base];
          var bb = (bc.bases || {})[base];
          if (rec && !rec.url && !rec.asset && bb && bb.asset) rec.asset = bb.asset;
        });
      });
    });

    return shop;
  }

  window.AriesReel = {
    mount: function (root, catalog, opts) { return new Reel(root, catalog, opts); },

    withBundled: withBundled,

    setLines: setLines,
    setName: setName,

    atRest: function (root) {
      var lines = root.querySelectorAll('.reel__line');
      for (var i = 0; i < lines.length; i++) {
        if (lines[i].__orbit) lines[i].__orbit.cancel();
      }
    },
    fitLines: fitLines,
    fitSwitch: fitSwitch,
    fitName: fitName,
  };
})();
